import styled from "styled-components";
import theme from "~/styles/theme";
import { motion } from "framer-motion";

export const StyledMotionDiv = styled(motion.div)`
  background-color: ${theme.palette.neutral.primary.key};

  .div {
    background-color: ${theme.palette.brand.terciary.light};
    border-bottom-left-radius: 48px;
    border-bottom-right-radius: 48px;
  }

  .products {
    text-align: center;

    img {
      max-width: 320px;

      @media (min-width: ${theme.breakpoints.values.md}px) {
        max-width: 670px;
      }
    }
  }
`;

export const FormText = styled.div`
  padding: 0 16px;
  margin: 0 auto;
  text-align: center;
  width: 100%;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    padding: 0;
  }

  h1 {
    color: ${theme.palette.neutral.primary.key};
  }
  p {
    font-family: ${theme.typography.fontFamilyRegular};
    color: ${theme.palette.neutral.primary.key};
    max-width: 310px;
    margin: 0 auto;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      max-width: 666px;
    }

    strong {
      font-family: ${theme.typography.fontFamily};
    }

    a {
      font-family: ${theme.typography.fontFamily};
      color: ${theme.palette.neutral.primary.key};
      text-decoration: underline;
    }
  }
`;

export const MarketList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  width: 100%;
  justify-content: center;
  padding: 0 20px;


  @media (min-width: ${theme.breakpoints.values.md}px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    padding: 0;
  }

  a {
    text-decoration: none;
  }
`;

export const MarketItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  width: 100%;
  height: 154px;
  background: ${theme.palette.neutral.primary.light};
  border-radius: 32px;

  img {
    width: 118px;
    height: 67px;
    object-fit: scale-down;
    margin-top: 8px;
  }

  a {
    margin: 16px 0 8px;
    text-decoration: none;
  }

  button {
    background-color: ${theme.palette.brand.primary.key};
    color: ${theme.palette.neutral.primary.light};
    height: 40px;
    padding: 5px 15px;

    &:hover {
      border-color: ${theme.palette.neutral.primary.medium};
      color: ${theme.palette.brand.primary.key};
      background-color: ${theme.palette.neutral.primary.medium};
    }

    span {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      text-transform: uppercase;
      text-decoration: none;
    }
  }

  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 240px;
    height: 238px;

    img {
      width: 192px;
      height: 120px;
    }

    button {
      height: 56px;
      width: 192px;
    }
  }
`;

export const Warning = styled.div`
  width: 100%;
  display: flex;
  background-color: #E398FF;
  padding: 15px 16px 14px 16px;
  border-radius: 32px;
  max-width: 1005px;
  margin: 0px 20px 40px 20px;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin: 0 0 40px 0 ;
    flex-direction: row;
    padding: 24px;
  }

  p {
    color: ${theme.palette.neutral.primary.key};
    margin-top: 16px;
    line-height: 22px;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      margin-top: 0;
      margin-left: 32px;
    }

    strong {
      font-weight: 500;
    }
  }
`;
